// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Loyalty Drawer ─────────────────────────────────────── */
.lyd-shell {
  position: absolute;
  top: 0;
  right: 0;
  width: min(480px, 100vw);
  height: 100vh;
  background: #ffffff;
  border-radius: 0;
  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.22);
  border-left: 1px solid #e2e8f0; /* slate-200 */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: lydDrawerIn 220ms cubic-bezier(0.16, 1, 0.3, 1);
  outline: none;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  box-sizing: border-box;
}

/* ── Header ── */
.lyd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9; /* slate-100 */
  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));
  flex-shrink: 0;
}

.lyd-title {
  margin: 0;
  font-size: 20px !important;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #0f172a; /* slate-900 */
  line-height: 1.2;
}

.lyd-close {
  background: none;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 36px;
  height: 36px;
  border-radius: 9999px;
  color: #64748b; /* slate-500 */
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
}

.lyd-close:hover {
  background: #f1f5f9; /* slate-100 */
  color: #0f172a;
}

/* ── Body ── */
.lyd-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
}

.lyd-body::-webkit-scrollbar {
  width: 6px;
}

.lyd-body::-webkit-scrollbar-track {
  background: transparent;
}

.lyd-body::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 9999px;
}

.lyd-body::-webkit-scrollbar-thumb:hover {
  background-color: #a0a0a0;
}

/* ── No customer state ── */
.lyd-no-customer {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.lyd-no-customer-card {
  border: 1px dashed #cbd5e1; /* slate-300 */
  border-radius: 24px;
  background: #ffffff;
  padding: 36px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  width: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
}

.lyd-no-customer-icon {
  width: 48px;
  height: 48px;
  border-radius: 9999px;
  border: 1px solid #e2e8f0; /* slate-200 */
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b; /* slate-500 */
  margin-bottom: 4px;
}

.lyd-no-customer-title {
  margin: 0;
  font-size: 16px !important;
  font-weight: 700;
  color: #0f172a;
}

.lyd-no-customer-sub {
  margin: 0;
  font-size: 13px !important;
  color: #64748b;
  line-height: 1.5;
  max-width: 280px;
}

.lyd-add-customer-btn {
  margin-top: 12px;
  height: 40px;
  padding: 0 24px;
  border: 1px solid transparent;
  border-radius: 12px;
  background: #3b82f6; /* blue-500 */
  color: #ffffff;
  font-size: 14px !important;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  transition: all 0.2s;
}

.lyd-add-customer-btn:hover {
  background: #2563eb; /* blue-600 */
}

/* ── Customer card ── */
.lyd-customer-card {
  border: 1px solid #e2e8f0; /* slate-200 */
  border-radius: 24px;
  background: #ffffff;
  padding: 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px -1px rgba(0, 0, 0, 0.05); /* shadow-sm */
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.lyd-customer-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.lyd-avatar {
  width: 48px;
  height: 48px;
  border-radius: 9999px;
  border: 1px solid #ffe4e6; /* rose-100 */
  background: #fff1f2; /* rose-50 */
  color: #f43f5e; /* rose-500 */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.lyd-customer-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
  padding-left: 4px;
}

.lyd-customer-name {
  font-size: 16px !important;
  font-weight: 700;
  color: #0f172a; /* slate-900 */
  margin: 0;
}

.lyd-customer-phone {
  font-size: 12px !important;
  font-weight: 500;
  color: #64748b; /* slate-500 */
  margin: 0;
}

.lyd-customer-email {
  font-size: 12px !important;
  color: #94a3b8; /* slate-400 */
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lyd-tier-badge {
  border-radius: 9999px;
  background: #fffbeb; /* amber-50 */
  padding: 4px 12px;
  font-size: 12px !important;
  font-weight: 600;
  color: #b45309; /* amber-700 */
  line-height: 1;
}

.lyd-customer-meta-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-top: 16px;
}

.lyd-meta-tile {
  border-radius: 16px;
  border: 1px solid #f1f5f9;
  background: #f8fafc;
  padding: 12px;
  box-sizing: border-box;
}

.lyd-meta-label {
  font-size: 10px !important;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8; /* slate-400 */
  margin: 0;
}

.lyd-meta-value {
  margin-top: 4px;
  font-size: 13px !important;
  font-weight: 700;
  color: #0f172a; /* slate-900 */
  margin-bottom: 0;
}

/* ── Stats tiles ── */
.lyd-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.lyd-stat-tile {
  border-radius: 22px;
  border: 1px solid #e2e8f0; /* slate-200 */
  background: #ffffff;
  padding: 16px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.lyd-stat-header {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #94a3b8; /* slate-400 */
}

.lyd-stat-header svg {
  width: 14px;
  height: 14px;
}

.lyd-stat-label {
  font-size: 10px !important;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8;
  margin: 0;
}

.lyd-stat-value {
  margin-top: 10px;
  font-size: 20px !important;
  font-weight: 700;
  color: #020617; /* slate-950 */
  margin-bottom: 0;
}

.lyd-stat-sub {
  font-size: 12px !important;
  color: #94a3b8;
  margin: 0;
  margin-top: 2px;
}

/* ── Section (Redemption card) ── */
.lyd-section {
  border: 1px solid #e2e8f0; /* slate-200 */
  border-radius: 24px;
  background: #ffffff;
  padding: 20px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px -1px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  gap: 16px; /* space-y-4 */
  box-sizing: border-box;
}

.lyd-section-label {
  font-size: 11px !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8; /* slate-400 */
  margin: 0;
  display: block;
}

.lyd-section-sub {
  margin: 0;
  margin-top: 4px;
  font-size: 14px !important;
  color: #64748b; /* slate-500 */
  line-height: 1.4;
}

.lyd-inputs-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.lyd-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.lyd-input-label {
  font-size: 11px !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8;
  margin: 0;
}

.lyd-input {
  display: flex;
  width: 100%;
  height: 48px;
  border-radius: 16px;
  border: 1px solid #e2e8f0; /* slate-200 */
  background: #f8fafc; /* slate-50 */
  padding: 0 16px;
  font-size: 14px !important;
  color: #0f172a;
  outline: none;
  box-sizing: border-box;
  transition: all 0.2s;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.lyd-input:focus {
  border-color: #cbd5e1;
  background: #ffffff;
}

.lyd-input::placeholder {
  color: #94a3b8;
}

.lyd-input:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.lyd-input::-webkit-outer-spin-button,
.lyd-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.lyd-preview-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  border-radius: 16px;
  border: 1px dashed #e2e8f0; /* slate-200 */
  background: #f8fafc; /* slate-50 */
  padding: 12px 16px;
  font-size: 14px !important;
  color: #64748b; /* slate-500 */
  box-sizing: border-box;
}

.lyd-preview-val {
  font-weight: 700;
  color: #0f172a; /* slate-900 */
}

/* ── OTP section ── */
.lyd-otp-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 22px;
  border: 1px solid #d1fae5; /* emerald-100 */
  background: rgba(236, 253, 245, 0.7); /* emerald-50/70 */
  padding: 16px;
  box-sizing: border-box;
}

.lyd-otp-header-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.lyd-otp-left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.lyd-otp-label {
  font-size: 11px !important;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #059669; /* emerald-600 */
  margin: 0;
  display: block;
}

.lyd-otp-sub {
  margin: 0;
  font-size: 14px !important;
  color: #047857; /* emerald-700 */
  line-height: 1.4;
}

.lyd-send-otp-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px !important;
  font-weight: 500;
  transition: all 0.2s;
  border: 1px solid #a7f3d0; /* emerald-200 */
  background: #ffffff;
  color: #047857; /* emerald-700 */
  padding: 8px 16px;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.lyd-send-otp-btn:hover:not(:disabled) {
  background: #d1fae5; /* emerald-100 */
}

.lyd-send-otp-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.lyd-otp-input {
  display: flex;
  width: 100%;
  height: 48px;
  border-radius: 16px;
  border: 1px solid #a7f3d0;
  background: #ffffff;
  padding: 0 16px;
  font-size: 14px !important;
  color: #0f172a;
  outline: none;
  box-sizing: border-box;
  margin-top: 8px;
}

.lyd-otp-resend {
  background: none;
  border: none;
  color: #059669;
  font-size: 12px !important;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 0;
  text-decoration: underline;
  text-align: left;
  width: fit-content;
}

/* ── Action button ── */
.lyd-redeem-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px !important;
  font-weight: 600;
  transition: all 0.2s;
  height: 48px;
  width: 100%;
  border-radius: 16px;
  border: 1px solid transparent;
  background-color: #e11d48; /* rose-600 */
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(244, 63, 94, 0.2); /* rose-500/20 */
  cursor: pointer;
}

.lyd-redeem-btn:hover:not(:disabled) {
  background-color: #be123c; /* rose-700 */
}

.lyd-redeem-btn:disabled {
  background-color: #e2e8f0; /* slate-200 */
  color: #64748b; /* slate-500 */
  box-shadow: none;
  cursor: not-allowed;
}

/* For removing loyalty points */
.lyd-redeem-btn--remove {
  background-color: #475569; /* slate-600 */
  box-shadow: 0 4px 12px rgba(71, 85, 105, 0.2);
}

.lyd-redeem-btn--remove:hover:not(:disabled) {
  background-color: #334155; /* slate-700 */
}

/* ── Loader / Blacklisted ── */
.lyd-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
}

.lyd-blacklisted {
  padding: 16px;
  background: #fef2f2;
  border: 1px solid #fee2e2;
  border-radius: 16px;
  color: #ef4444;
  font-size: 14px !important;
  font-weight: 500;
  text-align: center;
}

/* ── Slide-in ── */
@keyframes lydDrawerIn {
  from { transform: translateX(100%); }
  to   { transform: translateX(0); }
}

@media (max-width: 600px) {
  .lyd-shell {
    width: 100vw;
    border-radius: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/twoWaykeyboardPaymentPage/components/loyalty-popup/loyalty-drawer.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,8BAA8B,EAAE,cAAc;EAC9C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,0DAA0D;EAC1D,aAAa;EACb,uFAAuF;EACvF,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC,EAAE,cAAc;EAChD,yFAAyF;EACzF,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,wBAAwB;EACxB,cAAc,EAAE,cAAc;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc,EAAE,cAAc;EAC9B,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB,EAAE,cAAc;EACnC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B,EAAE,cAAc;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB,EAAE,cAAc;EACzC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc,EAAE,cAAc;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB,EAAE,aAAa;EAClC,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,mBAAmB,EAAE,aAAa;AACpC;;AAEA,wBAAwB;AACxB;EACE,yBAAyB,EAAE,cAAc;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,+EAA+E,EAAE,cAAc;EAC/F,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,yBAAyB,EAAE,aAAa;EACxC,mBAAmB,EAAE,YAAY;EACjC,cAAc,EAAE,aAAa;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,OAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,cAAc,EAAE,cAAc;EAC9B,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB,EAAE,aAAa;EAClC,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc,EAAE,cAAc;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB,EAAE,cAAc;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA,oCAAoC;AACpC;EACE,yBAAyB,EAAE,cAAc;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,+EAA+E;EAC/E,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,cAAc;EACzB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc,EAAE,cAAc;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,cAAc,EAAE,cAAc;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB,EAAE,cAAc;EACzC,mBAAmB,EAAE,aAAa;EAClC,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,0BAA0B,EAAE,cAAc;EAC1C,mBAAmB,EAAE,aAAa;EAClC,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc,EAAE,cAAc;EAC9B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc,EAAE,cAAc;AAChC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,yBAAyB,EAAE,gBAAgB;EAC3C,oCAAoC,EAAE,kBAAkB;EACxD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc,EAAE,gBAAgB;EAChC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,cAAc,EAAE,gBAAgB;EAChC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB,EAAE,gBAAgB;EAC3C,mBAAmB;EACnB,cAAc,EAAE,gBAAgB;EAChC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB,EAAE,gBAAgB;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB,EAAE,aAAa;EACxC,cAAc;EACd,6CAA6C,EAAE,gBAAgB;EAC/D,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,aAAa;AAC1C;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,cAAc,EAAE,cAAc;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB,EAAE,cAAc;EACzC,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB,EAAE,cAAc;AAC3C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":["/* ── Loyalty Drawer ─────────────────────────────────────── */\n.lyd-shell {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: min(480px, 100vw);\n  height: 100vh;\n  background: #ffffff;\n  border-radius: 0;\n  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.22);\n  border-left: 1px solid #e2e8f0; /* slate-200 */\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  animation: lydDrawerIn 220ms cubic-bezier(0.16, 1, 0.3, 1);\n  outline: none;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  box-sizing: border-box;\n}\n\n/* ── Header ── */\n.lyd-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f1f5f9; /* slate-100 */\n  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));\n  flex-shrink: 0;\n}\n\n.lyd-title {\n  margin: 0;\n  font-size: 20px !important;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: #0f172a; /* slate-900 */\n  line-height: 1.2;\n}\n\n.lyd-close {\n  background: none;\n  border: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 9999px;\n  color: #64748b; /* slate-500 */\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid transparent;\n}\n\n.lyd-close:hover {\n  background: #f1f5f9; /* slate-100 */\n  color: #0f172a;\n}\n\n/* ── Body ── */\n.lyd-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  box-sizing: border-box;\n}\n\n.lyd-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.lyd-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.lyd-body::-webkit-scrollbar-thumb {\n  background-color: #c1c1c1;\n  border-radius: 9999px;\n}\n\n.lyd-body::-webkit-scrollbar-thumb:hover {\n  background-color: #a0a0a0;\n}\n\n/* ── No customer state ── */\n.lyd-no-customer {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.lyd-no-customer-card {\n  border: 1px dashed #cbd5e1; /* slate-300 */\n  border-radius: 24px;\n  background: #ffffff;\n  padding: 36px 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  text-align: center;\n  width: 100%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  box-sizing: border-box;\n}\n\n.lyd-no-customer-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0; /* slate-200 */\n  background: #ffffff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #64748b; /* slate-500 */\n  margin-bottom: 4px;\n}\n\n.lyd-no-customer-title {\n  margin: 0;\n  font-size: 16px !important;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.lyd-no-customer-sub {\n  margin: 0;\n  font-size: 13px !important;\n  color: #64748b;\n  line-height: 1.5;\n  max-width: 280px;\n}\n\n.lyd-add-customer-btn {\n  margin-top: 12px;\n  height: 40px;\n  padding: 0 24px;\n  border: 1px solid transparent;\n  border-radius: 12px;\n  background: #3b82f6; /* blue-500 */\n  color: #ffffff;\n  font-size: 14px !important;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\n  transition: all 0.2s;\n}\n\n.lyd-add-customer-btn:hover {\n  background: #2563eb; /* blue-600 */\n}\n\n/* ── Customer card ── */\n.lyd-customer-card {\n  border: 1px solid #e2e8f0; /* slate-200 */\n  border-radius: 24px;\n  background: #ffffff;\n  padding: 20px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px -1px rgba(0, 0, 0, 0.05); /* shadow-sm */\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.lyd-customer-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.lyd-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 9999px;\n  border: 1px solid #ffe4e6; /* rose-100 */\n  background: #fff1f2; /* rose-50 */\n  color: #f43f5e; /* rose-500 */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.lyd-customer-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n  padding-left: 4px;\n}\n\n.lyd-customer-name {\n  font-size: 16px !important;\n  font-weight: 700;\n  color: #0f172a; /* slate-900 */\n  margin: 0;\n}\n\n.lyd-customer-phone {\n  font-size: 12px !important;\n  font-weight: 500;\n  color: #64748b; /* slate-500 */\n  margin: 0;\n}\n\n.lyd-customer-email {\n  font-size: 12px !important;\n  color: #94a3b8; /* slate-400 */\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lyd-tier-badge {\n  border-radius: 9999px;\n  background: #fffbeb; /* amber-50 */\n  padding: 4px 12px;\n  font-size: 12px !important;\n  font-weight: 600;\n  color: #b45309; /* amber-700 */\n  line-height: 1;\n}\n\n.lyd-customer-meta-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.lyd-meta-tile {\n  border-radius: 16px;\n  border: 1px solid #f1f5f9;\n  background: #f8fafc;\n  padding: 12px;\n  box-sizing: border-box;\n}\n\n.lyd-meta-label {\n  font-size: 10px !important;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8; /* slate-400 */\n  margin: 0;\n}\n\n.lyd-meta-value {\n  margin-top: 4px;\n  font-size: 13px !important;\n  font-weight: 700;\n  color: #0f172a; /* slate-900 */\n  margin-bottom: 0;\n}\n\n/* ── Stats tiles ── */\n.lyd-stats {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.lyd-stat-tile {\n  border-radius: 22px;\n  border: 1px solid #e2e8f0; /* slate-200 */\n  background: #ffffff;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n.lyd-stat-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #94a3b8; /* slate-400 */\n}\n\n.lyd-stat-header svg {\n  width: 14px;\n  height: 14px;\n}\n\n.lyd-stat-label {\n  font-size: 10px !important;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.lyd-stat-value {\n  margin-top: 10px;\n  font-size: 20px !important;\n  font-weight: 700;\n  color: #020617; /* slate-950 */\n  margin-bottom: 0;\n}\n\n.lyd-stat-sub {\n  font-size: 12px !important;\n  color: #94a3b8;\n  margin: 0;\n  margin-top: 2px;\n}\n\n/* ── Section (Redemption card) ── */\n.lyd-section {\n  border: 1px solid #e2e8f0; /* slate-200 */\n  border-radius: 24px;\n  background: #ffffff;\n  padding: 20px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px -1px rgba(0, 0, 0, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 16px; /* space-y-4 */\n  box-sizing: border-box;\n}\n\n.lyd-section-label {\n  font-size: 11px !important;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8; /* slate-400 */\n  margin: 0;\n  display: block;\n}\n\n.lyd-section-sub {\n  margin: 0;\n  margin-top: 4px;\n  font-size: 14px !important;\n  color: #64748b; /* slate-500 */\n  line-height: 1.4;\n}\n\n.lyd-inputs-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.lyd-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.lyd-input-label {\n  font-size: 11px !important;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.lyd-input {\n  display: flex;\n  width: 100%;\n  height: 48px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0; /* slate-200 */\n  background: #f8fafc; /* slate-50 */\n  padding: 0 16px;\n  font-size: 14px !important;\n  color: #0f172a;\n  outline: none;\n  box-sizing: border-box;\n  transition: all 0.2s;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.lyd-input:focus {\n  border-color: #cbd5e1;\n  background: #ffffff;\n}\n\n.lyd-input::placeholder {\n  color: #94a3b8;\n}\n\n.lyd-input:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.lyd-input::-webkit-outer-spin-button,\n.lyd-input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.lyd-preview-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  border-radius: 16px;\n  border: 1px dashed #e2e8f0; /* slate-200 */\n  background: #f8fafc; /* slate-50 */\n  padding: 12px 16px;\n  font-size: 14px !important;\n  color: #64748b; /* slate-500 */\n  box-sizing: border-box;\n}\n\n.lyd-preview-val {\n  font-weight: 700;\n  color: #0f172a; /* slate-900 */\n}\n\n/* ── OTP section ── */\n.lyd-otp-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  border-radius: 22px;\n  border: 1px solid #d1fae5; /* emerald-100 */\n  background: rgba(236, 253, 245, 0.7); /* emerald-50/70 */\n  padding: 16px;\n  box-sizing: border-box;\n}\n\n.lyd-otp-header-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.lyd-otp-left {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.lyd-otp-label {\n  font-size: 11px !important;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #059669; /* emerald-600 */\n  margin: 0;\n  display: block;\n}\n\n.lyd-otp-sub {\n  margin: 0;\n  font-size: 14px !important;\n  color: #047857; /* emerald-700 */\n  line-height: 1.4;\n}\n\n.lyd-send-otp-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px !important;\n  font-weight: 500;\n  transition: all 0.2s;\n  border: 1px solid #a7f3d0; /* emerald-200 */\n  background: #ffffff;\n  color: #047857; /* emerald-700 */\n  padding: 8px 16px;\n  border-radius: 12px;\n  cursor: pointer;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.lyd-send-otp-btn:hover:not(:disabled) {\n  background: #d1fae5; /* emerald-100 */\n}\n\n.lyd-send-otp-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.lyd-otp-input {\n  display: flex;\n  width: 100%;\n  height: 48px;\n  border-radius: 16px;\n  border: 1px solid #a7f3d0;\n  background: #ffffff;\n  padding: 0 16px;\n  font-size: 14px !important;\n  color: #0f172a;\n  outline: none;\n  box-sizing: border-box;\n  margin-top: 8px;\n}\n\n.lyd-otp-resend {\n  background: none;\n  border: none;\n  color: #059669;\n  font-size: 12px !important;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 4px 0;\n  text-decoration: underline;\n  text-align: left;\n  width: fit-content;\n}\n\n/* ── Action button ── */\n.lyd-redeem-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px !important;\n  font-weight: 600;\n  transition: all 0.2s;\n  height: 48px;\n  width: 100%;\n  border-radius: 16px;\n  border: 1px solid transparent;\n  background-color: #e11d48; /* rose-600 */\n  color: #ffffff;\n  box-shadow: 0 4px 12px rgba(244, 63, 94, 0.2); /* rose-500/20 */\n  cursor: pointer;\n}\n\n.lyd-redeem-btn:hover:not(:disabled) {\n  background-color: #be123c; /* rose-700 */\n}\n\n.lyd-redeem-btn:disabled {\n  background-color: #e2e8f0; /* slate-200 */\n  color: #64748b; /* slate-500 */\n  box-shadow: none;\n  cursor: not-allowed;\n}\n\n/* For removing loyalty points */\n.lyd-redeem-btn--remove {\n  background-color: #475569; /* slate-600 */\n  box-shadow: 0 4px 12px rgba(71, 85, 105, 0.2);\n}\n\n.lyd-redeem-btn--remove:hover:not(:disabled) {\n  background-color: #334155; /* slate-700 */\n}\n\n/* ── Loader / Blacklisted ── */\n.lyd-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 0;\n}\n\n.lyd-blacklisted {\n  padding: 16px;\n  background: #fef2f2;\n  border: 1px solid #fee2e2;\n  border-radius: 16px;\n  color: #ef4444;\n  font-size: 14px !important;\n  font-weight: 500;\n  text-align: center;\n}\n\n/* ── Slide-in ── */\n@keyframes lydDrawerIn {\n  from { transform: translateX(100%); }\n  to   { transform: translateX(0); }\n}\n\n@media (max-width: 600px) {\n  .lyd-shell {\n    width: 100vw;\n    border-radius: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
